var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-icon',_vm._b({attrs:{"icon":_vm.platformIcon,"type":_vm.colored ? _vm.platformColor : '',"pack":"fab"}},'b-icon',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }